import { createProvideInject } from '@collector/shared-ui'

export const [provideSuccessBadge, injectSuccessBadge] = createProvideInject<{
  showSuccessBadge: () => void
}>('successBadge')
